import { render, staticRenderFns } from "./SportsLotteryInfoCreateEdit.vue?vue&type=template&id=167a6b32&"
import script from "./SportsLotteryInfoCreateEdit.vue?vue&type=script&lang=js&"
export * from "./SportsLotteryInfoCreateEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports